import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { MatDialog } from '@angular/material';
import { ResultDialogComponent } from '../result-dialog/result-dialog.component';

import { AuthGuardService, UserService } from '@core/services';
import { CreditCardIframeComponent } from '../credit-card-iframe/credit-card-iframe.component';
import { CreditCardComponent } from '@app/component/credit-card/credit-card.component';

@Component({
  selector: 'app-billing-credit-card',
  templateUrl: './billing-credit-card.component.html',
  styleUrls: ['./billing-credit-card.component.css']
})

export class BillingCreditCardComponent implements OnInit, OnDestroy {

  @ViewChild(CreditCardIframeComponent)
  creditCard: CreditCardIframeComponent;

  @ViewChild(CreditCardComponent)
  creditCardCAD: CreditCardComponent

  reg: FormGroup;
  private billingSuccess = false;
  private user: any;
  private currencyType: number = 0;
  private subscription: Subscription;
  public errorMessage = '';
  private nextClicked = false;
  public rawCard: string;
  public isAmex: boolean;
  public isCustomerService: boolean = false;

  constructor(private _fb: FormBuilder,
    private _userService: UserService,
    private _router: Router,
    private _authGuard: AuthGuardService,
    private dialog: MatDialog) {
  }

  ngOnInit() {
    this.reg = this._fb.group({
      billingAddress: this._fb.group({
        name: new FormControl('', Validators.required),
        Address: new FormControl('', Validators.required),
        City: new FormControl('', Validators.required),
        StateProvince: new FormControl('', Validators.required),
        ZipPostal: new FormControl('', [Validators.required, Validators.maxLength(10)]),
        phoneNumber: new FormControl('', [Validators.required, Validators.maxLength(15)])
      }),
      creditCard: this._fb.group({
        CardNumber: new FormControl('', Validators.required),
        ExpireMonth: new FormControl('', Validators.required),
        ExpireYear: new FormControl('', Validators.required),
        CVV: new FormControl('', Validators.required)
      })
    });
    this.billingSuccess = false;

    this.subscription = this._userService.getUser().subscribe(user => {
      this.user = user;
      
      if (this.user.customerIdArray) {
        if (this.user.customerIdArray.length > 0) {
          this.setMailingAddressToBillingAddress();
          console.log(this.user.accountIndex);
        }

      }
    });

    if (this.user.customerIdArray.length > 0) {
      this._authGuard.getAccountInfo();
      console.log(this);
      console.log(this.user);
      this.getAccountSummary(this.user.customerIdArray[this.user.accountIndex].Id);
      console.log(this.user);
    }
    // this.setMailingAddressToBillingAddress();
    //this._authGuard.getAccountInfo();
    //console.log(this.user);

    if(localStorage.getItem('isCustomerService008c084!1') && localStorage.getItem('isCustomerService008c084!1') == 'true'){
      this.isCustomerService = true;
    }
    
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getAccountSummary(customerId){
    console.log(customerId);
    let data: string;
    data = JSON.stringify({ 'CustomerId': customerId });
    const accountSummaryUrl = 'portfolios/AccountSummary';

    this._authGuard.authenticatedPost(accountSummaryUrl, data).subscribe(
      result => {
        this._userService.setAccountSummaryArray(result);
        console.log(this.user);
        if(this.user.accountSummaryArray){
          if (this.user.accountSummaryArray.length > 0) {
              this.currencyType = this.user.accountSummaryArray[this.user.accountIndex].ProgramType;
              console.log(this);
          }
        }
      },
      error => {
        console.log('Error: ' + error);
      }
    );
  }

  onSubmit() {
    if(!this.isCustomerService){
      let cardData = this.setupAddCardData();
      console.log(cardData);
      if (!cardData.CardNumber && cardData && cardData.CardNumber.length <= 0) {
        let dialogRef = this.dialog.open(ResultDialogComponent, {
          data: {
            message: 'Please enter a valid card number.',
            alertType: 'danger',
            title: 'Card number is invalid'
          }
        });
      }
      else if (cardData.CVV === '') {
        let dialogRef = this.dialog.open(ResultDialogComponent, {
          data: {
            message: 'Please enter a valid CVV code.',
            alertType: 'danger',
            title: 'CVV code is missing'
          }
        });
      }else if(cardData.CVV.length < 3){
        let dialogRef = this.dialog.open(ResultDialogComponent, {
          data: {
            message: 'Please enter a valid CVV code',
            alertType: 'danger',
            title: 'CVV number is too short'
          }
        });
      }
      else if (this.isAmex && cardData.CVV.length < 4) {
        let dialogRef = this.dialog.open(ResultDialogComponent, {
          data: {
            message: 'CVV codes for American Express cards are 4 digits long and are displayed on the front of your card. Please make sure you have entered your information correctly.',
            alertType: 'danger',
            title: 'Invalid AmEx CVV'
          }
        });
      } else {

        if(cardData.CVV === '9999'){
          //console.log('overriding cvv');
          cardData.CVV = '';
        }

        if (this.nextClicked) {
          return false;
        } else{
          this.nextClicked = true;
          this.errorMessage = '';
          if (!this.billingSuccess) {
            this.sendBillingAddressDataToServer();
          } else{
            const creditCardData = this.setupAddCardData();
            this.sendCreditCardDataToServer(creditCardData);
          }
        
        }
      }
    } else {
      if (!this.billingSuccess) {
        this.sendBillingAddressDataToServer();
      } 
    }
  }

  private sendBillingAddressDataToServer() {
    const billingAddressData = this.setupBillingAddress();
    const insertBillingAddressEndpoint = 'portfolios/InsertBillingAddress';
    this._authGuard.authenticatedPost(insertBillingAddressEndpoint, billingAddressData).subscribe(
      result => {
        const creditCardData = this.setupAddCardData();
        const billingGroup = this.reg.value.billingAddress;
        this._userService.setBillingAddress(billingGroup.name, billingGroup.City, '', billingGroup.phoneNumber, billingGroup.ZipPostal, billingGroup.StateProvince, billingGroup.Address);
        console.log("billing after get user:", this.user);
        this.billingSuccess = true;
        if (!this.isCustomerService){
          this.sendCreditCardDataToServer(creditCardData);
        } else {
          let dialogRef = this.dialog.open(ResultDialogComponent, {
            data: {
              message: "Billing address saved successfully. Please logout and login to your support account now.",
              alertType: 'success',
              title: 'Support Registration'
            }
          });
        }
      },
      error => {
        console.log('billing error', error);
        this.billingSuccess = false;
        this.errorMessage = error;

        this.nextClicked = false;
        let dialogRef = this.dialog.open(ResultDialogComponent, {
          data: {
            message: error,
            alertType: 'danger',
            title: 'Failed to submit billing address'
          }
        });
      });
  }

  private setupBillingAddress() {
    console.log('billingAddress form data', this.reg.value.billingAddress);
    const billingAddressData = this.reg.value.billingAddress;
    billingAddressData.CustomerId = this.getCustomerId();
    billingAddressData.NameOnCard = this.reg.value.billingAddress.name;
    billingAddressData.PrimaryTx = this.reg.value.billingAddress.phoneNumber; // this is primary contact. Or phone number
    billingAddressData.UpdateUser = this.user.userName;
    return billingAddressData;
  }

  private sendCreditCardDataToServer(creditCardData: FormGroup | any) {
    const addCreditCardEndpoint = 'portfolios/AddCreditCard';
    if(this.launchCVVDialogs(creditCardData.CVV)){
      if(creditCardData.CVV === '9999'){
        creditCardData.CVV = '';
      }
    this._authGuard.authenticatedPost(addCreditCardEndpoint, creditCardData).subscribe(
      result => {
        this.user.creditCardId = result[0].web_insert_creditcard;
        this._router.navigateByUrl('/confirmpayment');
      },
      error => {
        this.errorMessage = error;
        console.log('credit card error', error);
        this.nextClicked = false;
        let dialogRef = this.dialog.open(ResultDialogComponent, {
          data: {
            message: error,
            alertType: 'danger',
            title: 'Failed to submit credit card'
          }
        });
      });
    } else {
        this.nextClicked = false;
    }

  }

  private setUpCreditCardData() {

    const creditCardData = this.reg.value.creditCard;
    creditCardData.CardNumber = this.rawCard;
    creditCardData.CustomerId = this.getCustomerId();
    creditCardData.NameOnCard = this.reg.value.billingAddress.name;
    creditCardData.ZipPostal = this.reg.value.billingAddress.ZipPostal;
    creditCardData.Address = this.reg.value.billingAddress.Address;
    creditCardData.IsPrimary = true;
    creditCardData.UpdateUser = this.user.userName;
    creditCardData.AccountId = this.user.accountSummaryArray[this.user.accountIndex].id;
    return creditCardData;
  }

  setupAddCardData() {
    // this (cardFromComponent) was done because context menu (right click) paste wasn't
    // updating this.rawCard so I used a ViewChild to get the updated value from
    // inside the child component.
    // Should look into reworking this, has some funky directive component interaction.
    //const cardFromComponent = this.creditCard.rawCard;

    const creditCardData:any = {};
    if (!this.isCustomerService){
      const currentCustomer = this.user.customerIdArray[this.user.customerIndex];
      const billingAddress = currentCustomer.BillingAddress;

      // if (this.currencyType === 10 || this.currencyType === 19) {
      //   creditCardData.CardNumber = this.creditCardCAD.creditCardForm.controls.CardNumber.value.replace(/ /g, "");
      //   creditCardData.ExpireMonth = this.creditCardCAD.creditCardForm.controls.ExpireMonth.value;
      //   creditCardData.ExpireYear = this.creditCardCAD.creditCardForm.controls.ExpireYear.value;
      //   creditCardData.CVV = this.creditCardCAD.creditCardForm.controls.CVV.value;
      // } else {
      creditCardData.CardNumber = this.creditCard.creditCardForm.controls.CardNumber.value.replace(/ /g, "");
      creditCardData.ExpireMonth = this.creditCard.creditCardForm.controls.ExpireMonth.value;
      creditCardData.ExpireYear = this.creditCard.creditCardForm.controls.ExpireYear.value;
      creditCardData.CVV = this.creditCard.creditCardForm.controls.CVV.value;
      //}
      
      creditCardData.CustomerId = this.getCustomerId();
      creditCardData.NameOnCard = this.getCustomerName();
      creditCardData.ZipPostal = billingAddress.PostalCode;
      creditCardData.Address = billingAddress.Street;
      creditCardData.IsPrimary = true;
      creditCardData.UpdateUser = this.user.userName;
      creditCardData.AccountId = this.user.accountSummaryArray[this.user.accountIndex].id;

    }

    return creditCardData;
  }

  private getCustomerId() {
    return this.user.customerIdArray[this.user.customerIndex].Id;
  }

  private getCustomerName() {
    let currentCustomer = this.user.customerIdArray[this.user.customerIndex];
    let name = currentCustomer.FirstName.trim() + " " + currentCustomer.LastName;
    return name;
  }

  private validateBilling() {

  }


  public isSameAsMailing(event) {

    if (event.target.checked) {
      this.setMailingAddressToBillingAddress();
    } else {
      this.clearBillingAddress();
    }


  }

  private setMailingAddressToBillingAddress() {

    const currentMailingAddress = this.user.customerIdArray[this.user.customerIndex].MailingAddress;

    this.reg.controls.billingAddress.patchValue({
      name: this.getCustomerName(),
      Address: currentMailingAddress.Street,
      City: currentMailingAddress.City,
      StateProvince: currentMailingAddress.Province,
      ZipPostal: currentMailingAddress.PostalCode,
      phoneNumber: currentMailingAddress.Phone1,
    });
  }

  private clearBillingAddress() {
    this.reg.controls.billingAddress.reset();
  }

  private launchCVVDialogs(cvv){
    if (cvv === '') {
      let dialogRef = this.dialog.open(ResultDialogComponent, {
        data: {
          message: 'Please enter a valid CVV code.',
          alertType: 'danger',
          title: 'CVV code is missing'
        }
      });
      return false;
    }else if(cvv.length < 3){
      let dialogRef = this.dialog.open(ResultDialogComponent, {
        data: {
          message: 'Please enter a valid CVV code',
          alertType: 'danger',
          title: 'CVV number is too short'
        }
      });
      return false;
    }
    else if (this.isAmex && cvv.length < 4) {
      let dialogRef = this.dialog.open(ResultDialogComponent, {
        data: {
          message: 'CVV codes for American Express cards are 4 digits long and are displayed on the front of your card. Please make sure you have entered your information correctly.',
          alertType: 'danger',
          title: 'Invalid AmEx CVV'
        }
      });
      return false;
    } else {

      return true;
    }
  }


}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/billing-credit-card/billing-credit-card.component.ts